import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import typeToView from "routing/typetoview";
import { IChartSelectEvent } from "../charts/types";
import DrillDownTable from "../tables/DrillDownTable";
import { ColumnDefinition } from "../tables/MeasureTableTypes";
import DrillDownModal from "./DrillDownModal";

const useStyle = makeThemedStyles("KPIDrillDown", (theme) => ({
  title: {
    display: "flex",
    fontWeight: 500,
    fontSize: "15px",
    color: "white",
    marginBottom: "10px",
    marginTop: "10px",
  },
}));

const KPIDrillDown = (
  props: React.PropsWithChildren<{
    title: string;
    items: ICardElementWithChildren[];
    onClose?: () => void;
    showModal?: IChartSelectEvent | null;
  }>
) => {
  const classes = useStyle();
  const ctx = useAppContext();
  const { showModal, onClose } = props;

  const activeItems = React.useMemo(() => {
    return showModal
      ? showModal.items
          .filter((el) => el.typename === "KPI" && el.STATUS === "1")
          .filter((el) => {
            return showModal?.name === "No Value"
              ? !el.rangevalue
              : t("configtypes." + el.rangename) === showModal?.name;
          })
      : [];
  }, [props.items, props.showModal, props.showModal?.items]);

  const pickBgColor = React.useMemo(() => {
    console.log("pickBgColor", activeItems, showModal);
    if (activeItems.length === 0) return "rgba(255,255,255,0.7)";
    const [el] = activeItems;
    return `#${el.rangecolor || "000000"}80`;
  }, [activeItems]);

  const link = useLink();

  const rowClick = React.useCallback((el: ICardElementWithChildren) => {
    link({ meaId: el.id, page: typeToView(el.typename) });
  }, []);

  const getColumns = (): ColumnDefinition<ICardElementWithChildren>[] => {
    const series = conf.getKPIPopupSeriesSettings();
    const cols = [
      {
        title: t("configtypes.KPI"),
        value: (el: any) => (
          <div>{getTranslatedAttribute(el.elem, "Name", ctx.language)}</div>
        ),
        onRowClick: rowClick,
      },
    ];
    for (let i = 0; i < series.length; i += 1) {
      cols.push({
        title: t(`configtypes.${series[i]}`),
        value: (el) => <div>{el.elem[`${series[i]}_prettyvalue`]}</div>,
        onRowClick: rowClick,
      });
    }
    return cols;
  };

  return (
    <DrillDownModal isOpen={!!showModal} onClose={onClose}>
      <div
        style={{
          background: pickBgColor,
          width: "100%",
          color: "black",
          padding: "30px",
        }}
      >
        <div className={classes.title}>{props.title}</div>
        <DrillDownTable
          width="610px"
          maxHeight="300px"
          columns={getColumns()}
          items={activeItems}
        />
      </div>
    </DrillDownModal>
  );
};

export default KPIDrillDown;
